import {useEffect} from 'react';

/**
 * Close an open overlay on Escape (capture phase so it runs before focus traps).
 */
export function useEscapeToClose(isActive, onClose) {
  useEffect(() => {
    if (!isActive || typeof onClose !== 'function') return undefined;

    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      event.stopPropagation();
      onClose();
    };

    document.addEventListener('keydown', handleKeyDown, true);

    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [isActive, onClose]);
}
